import RestAPI from '../components/Common/restApi';

export default class DataEnrichmentApi {
  static fetchOrganizationFromDataEnrichment() {
    const reqUrl = '/api/v2/pro/data_enrichment/organization';
    return RestAPI.get(reqUrl);
  }

  static fetchProFromDataEnrichment() {
    const reqUrl = '/api/v2/pro/data_enrichment/pro';
    return RestAPI.get(reqUrl);
  }
}
